<div class='grid-wrapper'>
  <div class="example-box" style="display:flex; justify-content: space-between; flex-wrap: wrap;">
    <div>
      Read:
      <a href="https://learn.flowstudio.app/restore-power-automate" target="learn"><fa-icon icon="user-graduate" style="margin-right:5px;" title="Learn"></fa-icon>Restore Power Automate</a>&nbsp;
    </div>
    <div>
      <b>FlowStudio / Version Snapshots</b> is a subscription feature <fa-icon icon="user-circle" title="subscription feature"></fa-icon> <br>
    </div>
  </div>
  @if (error) {
    <div class="example-box">
      {{error | json}}
    </div>
  }
  <div class="versions-toolbar">
    <button type="button"
      class="app-pill-btn app-pill-btn--primary"
      (click)="doRestore(null, false)">
      <i class="ms-Icon ms-Icon--Refresh flex-none" aria-hidden="true"></i>
      <span>Restore</span>
    </button>

    <button type="button"
      class="app-pill-btn"
      (click)="doDiff()">
      <i class="ms-Icon ms-Icon--BranchCompare flex-none" aria-hidden="true"></i>
      <span>Diff</span>
    </button>

    <button type="button"
      class="app-pill-btn"
      (click)="doRestore(null, true)">
      <i class="ms-Icon ms-Icon--Save flex-none" aria-hidden="true"></i>
      <span>Save Copy</span>
    </button>
  </div>
  <kendo-grid class="flow-versions" [data]="view" [sort]="state.sort" [sortable]="true" [filter]="state.filter" [selectable]="true"

    [rowHeight]="35" [resizable]="true"

    filterable="menu" (dataStateChange)="dataStateChange($event)" [scrollable]="'virtual'" [kendoGridSelectBy]="'Name'"
    [(selectedKeys)]="selection" #versiongrid>
    <kendo-grid-checkbox-column [showSelectAll]="false" [width]="12" [style]="{'max-width':'12px', 'padding':'4px'}" [headerStyle]="{'max-width':'12px', 'padding':'4px'}"></kendo-grid-checkbox-column>
    <kendo-grid-column field="VersionNumber" title="Version" [width]="50">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.VersionNumber}}
      </ng-template>
      <!-- <ng-template kendoGridFooterTemplate let-column="column">
      <span title='Total'>{{this.versions.length}}&nbsp;</span>
    </ng-template> -->
  </kendo-grid-column>
  <kendo-grid-column field="Modified" title="Modified Date" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date"
    [width]="200">
  </kendo-grid-column>
  <kendo-grid-column field="Size" title="Size" [width]="100" [filterable]="false">
  </kendo-grid-column>
  <!-- <kendo-grid-excel fileName="versions.xlsx"></kendo-grid-excel> -->
</kendo-grid>
<grid-context-menu [for]="versiongrid" [menuItems]="['Restore', 'Diff', 'Save Copy']" (select)="onSelect($event)">
</grid-context-menu>
@if (!this.ready) {
  <div class="loading">
    <div class="k-i-loading"></div>
  </div>
}
<div kendoDialogContainer></div>
</div>